/*eslint-disable*/ 
//This file was generated by `tools/generate-error-classes.ts`.
//Changes made to this file will be overwritten.
//Moreover, this file should be excluded from your linter, formatter and VCS.
import BaseError from "@/modules/errors/classes/BaseError.gen.ts";
export default class AuthRefreshRequestError extends BaseError {
    constructor(originalError?: Error) { super(1001004003, "request", "auth", "refresh", "auth_refresh_request", originalError); }
}
